/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Inicio",
    type: "basic",
    icon: "heroicons_outline:home",
    link: "/home",
  },
  {
    id: "metrics",
    title: "Métricas",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/metricas",
  },
  {
    id: "trucks",
    title: "Camiones",
    type: "basic",
    icon: "heroicons_outline:truck",
    link: "/trucks",
  },
  {
    id: "reports",
    title: "Reportes",
    type: "basic",
    icon: "heroicons_outline:document-text",
    link: "/reports",
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "home",
    title: "Home",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/home",
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
